import {getManagerHeader} from "../Login/functions";
import axios from "axios";
import {baseCmsApiUrl} from "../../assets/Constants";
import {base64DecodeUnicode} from "../../assets/functions";

export const getAllComments = async () => {
    const headers = getManagerHeader();

    return axios.get(baseCmsApiUrl + 'comments?role=manager', {headers})
        .then((response) => {
            console.log(response)
            console.log(response.data)
            // console.log(base64DecodeUnicode(response.statusText))
            return response.data;
        })
        .catch((e) => {
            console.error(e)
            console.log(base64DecodeUnicode(e.response.statusText))
            console.log(e.response.data)
        })
}

export const getCommentStatusText = (statuses) => {
    if (statuses[statuses.length -1 ].status == "INSERT")
        return <span className={"text-danger"}>بررسی نشده</span>;
    if (statuses[statuses.length -1 ].status == "CONFIRMED")
        return <span className={"text-primary"}>تایید شده</span>;

}